/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Weak_Bird_CallInputs */

const en_bright_weak_bird_call = /** @type {(inputs: Bright_Weak_Bird_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User import`)
};

const de_bright_weak_bird_call = /** @type {(inputs: Bright_Weak_Bird_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-Import`)
};

/**
* | output |
* | --- |
* | "User import" |
*
* @param {Bright_Weak_Bird_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_weak_bird_call = /** @type {((inputs?: Bright_Weak_Bird_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Weak_Bird_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_weak_bird_call(inputs)
	return de_bright_weak_bird_call(inputs)
});